import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';

const styles = {
  criteriaNavigation: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
    alignItems: 'center',
  },
  criteriaTitle: {
    fontSize: '2rem',
    lineHeight: '2.8rem',
    color: colors.neutral[900],
    letterSpacing: '0.0225em',
    margin: 0,
  },
  bulletList: {
    display: 'flex',
    listStyle: 'none',
    gap: '1rem',
    paddingLeft: 0,
  },
  bulletItem: {
    border: `0.1rem solid ${colors.neutral[700]}`,
    backgroundColor: colors.neutral.white,
    borderRadius: '50%',
    width: '1.6rem',
    height: '1.6rem',
    boxSizing: 'border-box',
  },
  activeBulletItem: {
    backgroundColor: colors.blue[600],
    border: `0.1rem solid ${colors.blue[600]}`,
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
